/* eslint-disable prettier/prettier */

'use strict';

const searchBase = require('base/search/search');
const wishlist = require('../product/wishlist');
const { get } = require('lodash');

const $document = $(document);
/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    const $updates = $results.find(selector);
    const $target = $(selector);
    $updates.find('[data-include-once="true"]').each(function () {
        const $item = $(this);
        const id = $item.attr('data-id');
        const $existingItem = $(`[data-id="${id}"]`);
        if ($existingItem.length > 0) {
            $item.remove();
        }
    });
    $target.empty().html($updates.html());
    $('body').trigger('search:updateDom', selector);
    $document.trigger('rangeSlider:fillSlider');
}

/**
 *
 * Update the most recent filter_tracking event for the same parent.
 * @param {boolean} isSelectedFilter - jQuery DOM element
 * Assumes each event.sub_filter is already an array.
 */
function filterTrackingSelections(isSelectedFilter) {
    const dataLayer = window.dataLayer || [];
    if (dataLayer.length === 0) return;
    const latestIndex =
        [...dataLayer]
            .map((e, i) => ({ e, i }))
            .reverse()
            .find((item) => item.e?.event === 'filter_tracking')?.i ?? -1;
    if (latestIndex === -1) return;
    const latestEvent = dataLayer[latestIndex];
    const parentFilter = latestEvent.filter;
    const chosenValues = Array.isArray(latestEvent.sub_filter) ? latestEvent.sub_filter.slice() : [];

    const previousIndex =
        dataLayer
            .slice(0, latestIndex)
            .map((e, i) => ({ e, i }))
            .reverse()
            .find((item) => item.e?.event === 'filter_tracking' && item.e.filter === parentFilter)?.i ?? -1;
    let currentValues = [];
    if (previousIndex !== -1) {
        currentValues = Array.isArray(dataLayer[previousIndex].sub_filter) ? dataLayer[previousIndex].sub_filter.slice() : [];
    }
    currentValues = isSelectedFilter
        ? currentValues.filter((value) => !chosenValues.includes(value))
        : currentValues.concat(chosenValues.filter((v) => !currentValues.includes(v)));
    dataLayer[latestIndex].sub_filter = currentValues;
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    const view = $('.switch-view-container [name=view]:checked').val();
    if (view) {
        $results.find('[name=view]').each(function () {
            var thisVal = $(this).val();
            if (thisVal === view) {
                $results.find('#' + thisVal).attr('checked', 'checked');
            } else {
                $results.find('#' + thisVal).removeAttr('checked');
            }
        });
    }

    $('.refinement .collapse.show').each(function () {
        var activeDiv = $results.find('.' + $(this)[0].id);
        activeDiv.find('.collapse').addClass('show');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    $results.find('.refinement-bar').addClass($('.refinement-bar').attr('class'));

    if ($('.sort-order-body').hasClass('show')) {
        $results.find('.sort-order-body').addClass('show');
    }

    // Update DOM elements that do not require special handling
    ['.search-results-container', '.header.page-title'].forEach(function (selector) {
        updateDom($results, selector);
    });
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} data - Ajax response HTML code
 * @return {undefined}
 */
function updateCategoryVisualFilter() {
    searchBase.handleVisualFilterSelectionOnPageLoad();
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} data - Ajax response HTML code
 * @return {undefined}
 */
function updateVisualFilter(data) {
    if ($('.visual-filter-wrapper').length > 0) {
        const visualFilterAttributeId = $('.visual-filter-wrapper .discover-categories__tiles-wrapper').data('attribute-id');
        $('.visual-filter-wrapper .filter-customfltbtn').each((index, button) => {
            const jQueryButton = $(button);

            jQueryButton.removeClass('filterselected filter-state-selected disabled');

            const visualFilterValue = jQueryButton.data('technical-value');
            const selector = `[data-filterattribute-id="${visualFilterAttributeId}"] [data-display-value="${visualFilterValue}"]`;
            const filterInFilterBar = $(data).find(selector);
            if (filterInFilterBar.length > 0) {
                jQueryButton.attr('href', filterInFilterBar.data('href'));
                jQueryButton.data('href', filterInFilterBar.data('href'));

                if (filterInFilterBar.is(':disabled')) {
                    jQueryButton.addClass('disabled');
                }

                jQueryButton.find('.visual-filter-count').text(filterInFilterBar.find('.refinement-count').text());

                jQueryButton.data('seo-href', filterInFilterBar.data('seo-href'));
                if (filterInFilterBar.hasClass('filter-state-selected')) {
                    jQueryButton.addClass('filter-state-selected');
                    jQueryButton.addClass('filterselected');
                }
            }
        });
    }
}

/* eslint-disable camelcase */
/**
 * Updates the existing 'visual_filters' event in the dataLayer with selected filter details.
 *
 * This function finds the existing 'visual_filters' event in the dataLayer,
 * resets its selectedFilters array, and populates it based on the visual filter buttons
 * present in the provided HTML response.
 *
 * @param {HTMLElement | string} data - The HTML response from an AJAX call, either as a DOM element or HTML string.
 *
 * @returns {void}
 */
function updateDataLayer(data) {
    if (window.dataLayer) {
        const vf_event = window.dataLayer.find((event) => event.event === 'visual_filters');
        if (!vf_event) {
            return;
        }
        vf_event.selectedFilters = [];
        var filter_type = $(data).find('.visual-filter-wrapper .discover-categories__tiles-wrapper').data('attribute-id');
        var filter_number = 0;
        $(data)
            .find('.visual-filter-wrapper .filter-customfltbtn')
            .each((index, element) => {
                if ($(element).hasClass('filterselected')) {
                    filter_number += 1;
                    var event_data = [];
                    event_data.filter_type = filter_type;
                    event_data.filter_value = $(element).data('technical-value');
                    vf_event.selectedFilters.push(event_data);
                }
            });
        vf_event.filter_number = filter_number;
        window.dataLayer.push(vf_event);
    }
}
/* eslint-enable camelcase */

/**
 * Adds a query parameter to a given URL.
 * @param {string} path - The original URL to which the parameter should be added.
 * @param {string} key - The name of the parameter to add.
 * @param {string} value - The value of the parameter to add.
 * @returns {string} - The updated URL with the new parameter.
 */
function addUrlParameter(path, key, value) {
    const baseURL = 'https://test.com/';
    let url = new URL(path, baseURL);

    if (url.searchParams.has(key)) {
        url.searchParams.set(key, value);
    } else {
        url.searchParams.append(key, value);
    }

    return url.pathname + url.search;
}

searchBase.applyFilter = function () {
    $document.on('keydown', '.search-results-search input', function (e) {
        const $thisVal = $(this).val();
        if (e.keyCode === 13 || e.which === 13) {
            e.preventDefault();
            $(this).closest('.search-results-search').find('button[type=submit]').click();
        }
        if ($thisVal) {
            $(this).parent().find('.invalid-feedback').removeClass('d-block');
        }
    });
    const $filter = $('.filter-reset').first();
    const initialResetUrl = $filter.data('href');
    const initialResetSeoUrl = $filter.data('seo-href');
    // Handle refinement value selection and reset click
    $document.on('click', '.refinements li button, .filter-reset, .filter-value button, .swatch-filter button, .filter-customfltbtn, .search-results-header button', function (e) {
        e.preventDefault();
        const $this = $(this);
        var isSelectedFilter = false;

        if (!$this.hasClass('disabled')) {
            var searchUrl = $this.data('href');
            var seoUrl = $this.data('seo-href') || searchUrl;
            if ($(this).hasClass('filter-reset')) {
                searchUrl = initialResetUrl;
                seoUrl = initialResetSeoUrl || searchUrl;
            }

            var $categoryRefinementViewAllBtn = $('.view-all-visual-filters-btn');
            const $searchWrapper = $this.closest('.search-results-header');
            if ($searchWrapper.length) {
                const $inputVal = $searchWrapper.find('input').val();
                searchUrl = $searchWrapper.attr('action');
                seoUrl = $searchWrapper.attr('seo-href');
                if ($inputVal) {
                    searchUrl = addUrlParameter(searchUrl, 'q', $inputVal);
                    seoUrl = addUrlParameter(seoUrl, 'q', $inputVal);
                } else {
                    $searchWrapper.find('.invalid-feedback').addClass('d-block');
                    return false;
                }
            }
            $.spinner().start();
            $this.trigger('search:filter', e);
            if ($this.hasClass('category-visual-filter')) {
                if ($this.hasClass('category-visual-filter-active')) {
                    if ($categoryRefinementViewAllBtn.length) {
                        searchUrl = $categoryRefinementViewAllBtn.data('fallback-url');
                        seoUrl = $categoryRefinementViewAllBtn.data('fallback-url');
                        $this.removeClass('category-visual-filter-active');
                        $('.visual-filter-wrapper .discover-categories__tiles-wrapper .view-all-visual-filters-btn').addClass('category-visual-filter-active');
                    }
                } else {
                    $('.visual-filter-wrapper .filter-customfltbtn').removeClass('category-visual-filter-active');
                    $this.addClass('category-visual-filter-active');
                }
            }

            if ($this.hasClass('filter-state-selected')) {
                searchUrl = addUrlParameter(searchUrl, 'action', 'unselect');
                seoUrl = addUrlParameter(seoUrl, 'action', 'unselect');
                isSelectedFilter = true;
            }
            filterTrackingSelections(isSelectedFilter);

            if (seoUrl) {
                window.history.pushState({}, null, seoUrl);
            }
            var attributeId = $this.find('span').last().attr('id');
            searchUrl = addUrlParameter(searchUrl, 'ajax', true);
            $.ajax({
                url: searchUrl,
                data: {
                    page: $('.grid-footer').data('page-number'),
                    selectedUrl: searchUrl,
                },
                method: 'GET',
                success: function (response) {
                    parseResults(response);
                    if ($this.hasClass('category-visual-filter') || $(e.target).closest('#refinement-category').length) {
                        updateCategoryVisualFilter(response);
                    } else {
                        updateVisualFilter(response);
                        updateDataLayer(response);
                    }
                    $.spinner().stop();
                    if (attributeId) {
                        $(`[id="${attributeId}"]`).parent('button').focus();
                    }
                    $document.trigger('initializeFilterCarousel');
                    $document.trigger('initProductCarousel', {
                        element: $('.product-carousel'),
                    });
                    $document.trigger('reloadEinstein');
                    $document.trigger('wishlist:check');
                    var position = $('.search-results').offset().top - $('.main-header-component').height();
                    $('html, body').animate(
                        {
                            scrollTop: position,
                        },
                        500
                    );
                    $('body').removeClass('scroll-down').addClass('scroll-up');
                },
                error: function () {
                    $.spinner().stop();
                    $(`[id="${attributeId}"]`).parent('button').focus();
                },
            });
        }
        return true;
    });
};

searchBase.sort = function () {
    // Handle sort order menu selection
    $document.on('change', '[name=sort-order]', function (e) {
        e.preventDefault();
        e.stopPropagation();

        $.spinner().start();
        $(this).trigger('search:sort', this.value);
        $.ajax({
            url: this.value,
            data: { selectedUrl: this.value },
            method: 'GET',
            success: function (response) {
                const $body = $('body');
                $('.product-grid').empty().html(response);
                $body.trigger('search:updateDom', '.product-grid');

                const target = e.target;
                const parentWrapper = target?.closest('.sort-order-body-wrapper');
                const label = document.querySelector(`label[for="${target?.id}"]`);
                $body.trigger('gtm:trigger:event', {
                    eventId: get(parentWrapper, 'dataset.event', ''),
                    data: {
                        id: target?.id,
                        type: get(label, 'textContent', '').trim(),
                        searchResult: parseInt(get(parentWrapper, 'dataset.eventPayload', ''), 10),
                    },
                });
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            },
        });
    });
};

searchBase.switchView = function () {
    // Handle sort order menu selection
    $document.on('change', '[name=view]', function () {
        $('.search-results').attr('data-view', this.value);
    });
};

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

/**
 * Update show more URL
 * @param {string} showMoreUrl - show more URL
 */
function updateShowMoreURL(showMoreUrl) {
    const url = new URL(showMoreUrl);
    const params = new URLSearchParams(url.search);
    const currentStart = parseInt(params.get('start'), 10);
    const currentSize = parseInt(params.get('sz'), 10);
    const newSize = currentStart + currentSize;
    const currentWindowUrl = new URL(window.location.href);
    // Sync updated params to current window URL
    currentWindowUrl.searchParams.set('start', 0);
    currentWindowUrl.searchParams.set('sz', newSize);
    currentWindowUrl.searchParams.set('newPageSize', currentSize);
    window.history.replaceState({}, null, currentWindowUrl.href);
}

searchBase.showMore = function () {
    // Show more products
    $document.on('click', '.show-more button, .show-more a', function (e) {
        e.preventDefault();
        const $this = $(this);
        $this.trigger('search:showMore', e);
        let showMoreUrl = $this.attr('data-href');
        $.spinner().start();
        $.ajax({
            url: showMoreUrl,
            data: { selectedUrl: showMoreUrl },
            method: 'GET',
            success: function (response) {
                const $body = $('body');
                $body.trigger('search:beforeUpdateDom');
                $('.grid-footer').replaceWith(response);
                $body.trigger('search:updateDom', '.grid-footer');
                $document.trigger('wishlist:check');
                $('.search-results-count').text($('.show-more-summary').text());
                updateSortOptions(response);
                if ($('.container').hasClass('search-results')) {
                    $body.trigger('search:updatelook');
                }
                updateShowMoreURL(showMoreUrl);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            },
        });
    });
};

searchBase.retainScrollPositionOnBrowserBack = function () {
    if ($('.container').hasClass('search-results')) {
        var plpLastScrollPosition = sessionStorage.getItem('plpLastScrollPosition');
        if (plpLastScrollPosition) {
            $('.row.product-grid').html(plpLastScrollPosition);
            $('body').trigger('search:updatelook');
        }
    }
};

searchBase.handleVisualFilterSelectionOnPageLoad = function () {
    if ($('.container').hasClass('search-results') && $('.category-visual-filter').length) {
        const params = new URLSearchParams(window.location.search);
        let subCategoryID = '';
        let $viewAllCategoryVisualFiltersBtn = $('.view-all-visual-filters-btn');
        if (params.get('category-id')) {
            subCategoryID = params.get('category-id');
        } else {
            const pathParts = window.location.pathname.split('/');
            subCategoryID = pathParts[pathParts.length - 1];
        }
        $('.visual-filter-wrapper .filter-customfltbtn').removeClass('category-visual-filter-active');
        if (subCategoryID && $viewAllCategoryVisualFiltersBtn.data('filter-name') !== subCategoryID) {
            $('.visual-filter-wrapper .discover-categories__tiles-wrapper a').each(function () {
                if (subCategoryID === $(this).data('filter-id')) {
                    $(this).addClass('category-visual-filter-active');
                }
            });
        } else {
            $viewAllCategoryVisualFiltersBtn.addClass('category-visual-filter-active');
        }
    }
};

searchBase.hoverWishlistForm = wishlist.methods.hoverWishlistForm;
searchBase.initAddWishlistForm = wishlist.methods.initAddWishlistForm;
searchBase.initRemoveWishlistForm = wishlist.methods.initRemoveWishlistForm;
searchBase.productTileRemoveWishlistForm = wishlist.methods.productTileRemoveWishlistForm;
module.exports = searchBase;
